module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warning",
    class: {
      'warning_active': _vm.active
    }
  }, [_c('div', {
    staticClass: "warning__wrap"
  }, [_c('h3', {
    staticClass: "warning__text"
  }, [_vm._t("default")], 2), _c('div', {
    staticClass: "warning__bottom"
  }, [_c('button', {
    staticClass: "warning__button warning__button_border",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('click', 'progress')
      }
    }
  }, [_vm._v("Перейти")]), _c('button', {
    staticClass: "warning__button",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('click', 'proceed')
      }
    }
  }, [_vm._v("Остаться")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-775aac4e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/warning/Warning.vue
// module id = d4323970badc422322df
// module chunks = 89